













































































import { gsap } from "gsap";
import FormSearch from "@/common/components/atoms/FormSearch.vue";
import ButtonRefine from "@/common/components/atoms/ButtonRefine.vue";
import ButtonRefineBase from "@/common/components/atoms/ButtonRefineBase.vue";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";

@Component({
  components: {
    FormSearch,
    ButtonRefine,
    ButtonRefineBase,
    ValidationErrorText
  }
})
export default class TheTemplateL extends Vue {
  @Prop({ type: String, default: null }) error!: string;

  isSp!: boolean;
  closeModalState!: boolean;
  search = "";
  searchUriBase: Array<string> = ["/l01/"];
  executeSearchFormDomAnimation = false;
  shownSearchFormState!: boolean;
  searchFormClassName = "p-the-template-l__search--animation";
  serchFormStyle: Record<string, any> = {
    visibility: "hidden",
    opacity: 0
  };

  @Prop({ type: Object }) sorted!: any;
  @Prop({ type: [String, Boolean], default: false, required: true }) heading!:
    | string
    | boolean;
  @Prop({ type: [String, Boolean], default: false, required: true })
  filterHeading!: string | boolean;
  @Prop({ type: Array, default: ["search", "button"] }) indicatedItem!: Array<
    string
  >;
  @Prop({ type: String, default: "キーワードで探す" })
  searchPlaceholder!: string;
  @Prop({ type: String, default: "" }) searchKeyword!: string;

  get indicateSearchForm() {
    const indicatedItem = this.indicatedItem;
    const keyword = "search";
    return indicatedItem.includes(keyword);
  }

  get indicateSearchButton() {
    const indicatedItem = this.indicatedItem;
    return indicatedItem.includes("searchButton");
  }

  get indicateSortedButton() {
    const indicatedItem = this.indicatedItem;
    const keyword = "sorted";
    return indicatedItem.includes(keyword);
  }

  get contentElementStyle() {
    const executeSearchFormDomAnimation = this.executeSearchFormDomAnimation;
    let styleObject = {};

    if (executeSearchFormDomAnimation === false) {
      styleObject = {
        marginTop: 0
      };
    }

    return styleObject;
  }

  get isSmartPhone() {
    if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
      return true;
    } else {
      return false;
    }
  }

  @Watch("isSp")
  onIsSp() {
    this.initSearchFormDomAnimation();
  }

  @Watch("shownSearchFormState")
  onShownSearchFormState() {
    this.animationSearchFormDom(this.$refs.searchFormElement);
  }

  doSort($event: any) {
    this.$emit("do-sort", $event);
  }

  mounted() {
    this.indicatedItem;
    this.heading;
    this.searchKeyword;
    this.shownSearchFormState = false;
  }

  async created() {
    this.indicatedItem;
    this.heading;
    this.searchKeyword;
    this.initSearchFormDomAnimation();
    this.initSearchKeyword();
  }

  initSearchKeyword() {
    this.search = this.searchKeyword;
  }

  async doSearch() {
    this.$emit("do-search", this.searchKeyword);
  }

  switchSortedState(value: any) {
    this.sorted.shownState = value;
  }

  switchSearchFormState() {
    this.shownSearchFormState = !this.shownSearchFormState;
    if (this.serchFormStyle.visibility == "hidden") {
      this.serchFormStyle.visibility = "inherit";
      this.serchFormStyle.opacity = 1;
    } else if (this.serchFormStyle.visibility == "inherit") {
      this.serchFormStyle.visibility = "hidden";
      this.serchFormStyle.opacity = 0;
    }
  }

  initSearchFormDomAnimation() {
    const { isSp, indicateSearchButton } = this;
    const executeSearchFormDomAnimation = isSp && indicateSearchButton;

    this.executeSearchFormDomAnimation = executeSearchFormDomAnimation;
    this.shownSearchFormState = !executeSearchFormDomAnimation;
  }

  animationSearchFormDom(el: any, shown = this.shownSearchFormState) {
    const executeSearchFormDomAnimation = this.executeSearchFormDomAnimation;
    const { contentElement } = this.$refs;
    const speed = 0.2;
    const animationStyle = {
      formSearchElement: {
        autoAlpha: shown ? 1 : 0
      },
      contentElement: {
        marginTop:
          shown && executeSearchFormDomAnimation ? `${60 / 16}rem` : "0rem"
      }
    };

    gsap.to(el, speed, animationStyle.formSearchElement);
    gsap.to(contentElement, speed, animationStyle.contentElement);
  }
}
